import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string.isRequired,
  labelClassName: PropTypes.string,

  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.array,
  // any other input prop
}

const defaultProps = {
  labelClassName: null
}

// Floating-label input for the Gateway. The look is defined entirely by the
// `.mui-input` rules in gateway.scss (self-contained, no Bootstrap), so this
// renders plain <label>/<input> elements rather than react-bootstrap.
const MuiInput = (props) => {
  const { label, labelClassName, error, ...inputProps } = props;

  const errorMessage = error && error.length ? error.join(", ") : null;

  return (
    <div className={ `mui-input ${!!inputProps.value ? " filled" : ""}` }>
      <label className={ labelClassName }>
        { label }
      </label>
      <input placeholder={ label } { ...inputProps } />
      { errorMessage && <div className="mui-input-error">{ errorMessage }</div> }
    </div>
  )
};

MuiInput.propTypes = propTypes;
MuiInput.defaultProps = defaultProps;

export default MuiInput;
